import { useContext, useState } from 'react'
import { observer } from 'mobx-react'
import { Button, Popup } from '@components/Generic'
import { StoreContext } from '@store/Root.store'
import { SignDocumentCore } from '@/components/SignDocumentCore/SignDocumentCore'

export const LtqcSignDocumentPage = observer(() => {
  const store = useContext(StoreContext)
  const { signDocumentPage: trans } = store.TranslationsState.translationsNew

  const { context } = store.ScenarioState

  const [infoPopupVisible, setInfoPopupVisible] = useState(
    !!context?.forceScrollingBeforeDocumentAccept
  )

  return (
    <>
      <SignDocumentCore
        transOverwrite={trans}
        showButtonHint
        showBlurOnSuccess
        groupedDocuments
        showNumberOfDocuments
      />
      <Popup
        visibility={infoPopupVisible}
        handleVisibility={setInfoPopupVisible}
        className="generic__scroll-document-popup sign-doc-core__popup"
      >
        <p className="generic__scroll-document-popup-body">{trans.popupDescription}</p>
        <div className="generic__spacer h-20" />
        <div className="layout__content-to-right">
          <Button onClick={() => setInfoPopupVisible(false)} className="sign-doc-core__popup-btn">
            {trans.popupButton}
          </Button>
        </div>
      </Popup>
    </>
  )
})
